import { useEffect } from 'react'
import { useCurrentRefinements, useSearchBox } from 'react-instantsearch'
import { isEmpty } from 'remeda'
import { AlgoliaFilters } from '@components/AlgoliaSearch/AlgoliaFilters'
import { useAlgoliaFilters } from '@components/AlgoliaSearch/AlgoliaSearchProvider'
import { SearchResultsList } from '@components/SearchResults/SearchResultsList'
import { useCategoryStore } from '@velasca/hooks/use-category-store'
import { SansText } from '@velasca/ui/sans-text'
import { SerifTitle } from '@velasca/ui/serif-title'
import { $settings } from '@velasca/utils/globals'
import * as S from './SearchResults.styles'

// Create a search-specific wrapper that provides mock category data
// since facets section relies on category data to render correctly
export const SearchResults = () => {
  const { isSearchActive, searchOnPageLoad } = useAlgoliaFilters()
  const { items } = useCurrentRefinements()
  const { query } = useSearchBox()
  const hasQuery = !isEmpty(query)

  // Initialize category store with search-specific data
  const setCurrentCategoryName = useCategoryStore(
    (state) => state.setCurrentCategoryName,
  )
  const setCurrentCategoryTitle = useCategoryStore(
    (state) => state.setCurrentCategoryTitle,
  )
  const setCurrentCategoryHasShoes = useCategoryStore(
    (state) => state.setCurrentCategoryHasShoes,
  )
  const setCurrentCategoryDescriptionHTML = useCategoryStore(
    (state) => state.setCurrentCategoryDescriptionHTML,
  )
  const setCurrentCategoryIsMainCollection = useCategoryStore(
    (state) => state.setCurrentCategoryIsMainCollection,
  )
  const setCurrentCategoryIsSubCollection = useCategoryStore(
    (state) => state.setCurrentCategoryIsSubCollection,
  )

  // Initialize with search-specific mock data
  useEffect(() => {
    setCurrentCategoryName('search')
    setCurrentCategoryTitle('Search Results')
    setCurrentCategoryHasShoes(false)
    setCurrentCategoryDescriptionHTML('')
    setCurrentCategoryIsMainCollection(false)
    setCurrentCategoryIsSubCollection(false)
  }, [
    setCurrentCategoryName,
    setCurrentCategoryTitle,
    setCurrentCategoryHasShoes,
    setCurrentCategoryDescriptionHTML,
    setCurrentCategoryIsMainCollection,
    setCurrentCategoryIsSubCollection,
  ])

  return (
    <S.Container>
      <S.Header>
        <S.Quote />
        <S.HeaderTitles>
          {hasQuery ? (
            <>
              <SansText size="base">
                {$settings.algolia_search_results_label}
              </SansText>
              <SerifTitle color="primary" size="md">
                {query}
              </SerifTitle>
            </>
          ) : (
            <SerifTitle color="primary" size="md">
              {$settings.algolia_simple_search_results_label}
            </SerifTitle>
          )}
        </S.HeaderTitles>
      </S.Header>
      <AlgoliaFilters alwaysShowsActiveRefinements />
      {(!isEmpty(items) || searchOnPageLoad || isSearchActive) && (
        <SearchResultsList showProductType />
      )}
    </S.Container>
  )
}
